import { HelperCore } from '@/common/dependencies';
import client from '@/store/client';
import React from 'react';

const VipTag = ({ text = 'VIP', style = {} , url = '' }) => {
 const isSe = client.is360se || (HelperCore.isMac() &&  client.isLLQ)

  return  <span style={{
    position: 'relative',
    left: isSe ? !url ? '-10px':'' : '0',
  }}>
       {isSe ? <img src={url || 'https://p4.ssl.qhimg.com/t110b9a930150ec22e799626e1b.png'} alt="" srcset="" width={44} height={22} /> :  <img src="https://p3.ssl.qhimg.com/t110b9a9301a348b94460e5efe3.png" alt="" srcset="" width={74} height={22}/>}
    </span>
};

export default VipTag;